import React from "react";
import { Event, User } from "../types/Types";
import { ListGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { getEventBadgeColor, getEventTypeLabel } from "./eventDisplay";

interface EventCardProps {
  event: Event;
  onClick?: () => void;
  showDescription?: boolean;
  isLastItem?: boolean;
  clickable?: boolean;
  currentUser?: User;
}

const EventCard: React.FC<EventCardProps> = ({ 
  event, 
  onClick, 
  showDescription = true, 
  isLastItem = false,
  clickable = false,
  currentUser
}) => {
  const canEdit = currentUser && (currentUser.admin || currentUser.id === event.userId);
  const formatDate = (date: Date): string => {
    const day = new Date(date).getDate();
    const suffix = ['th', 'st', 'nd', 'rd'][((day % 100) - 20) % 10] || 
                   ['th', 'st', 'nd', 'rd'][day % 100] || 'th';
    return new Date(date).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }).replace(/^\d+/, `${day}${suffix}`);
  };

  const handleClick = () => {
    if (canEdit && onClick) {
      onClick();
    } else if (!canEdit && onClick) {
      onClick();
    }
  };

  return (
    <ListGroup.Item 
      onClick={onClick ? handleClick : undefined}
      style={{ 
        cursor: onClick ? 'pointer' : 'default',
        backgroundColor: '#444',
        padding: '0.75rem',
        marginBottom: isLastItem ? '0' : '0.5rem',
        borderRadius: '0.25rem',
        border: 'none',
        position: 'relative'
      }}
    >
      <div>
        <div className="mb-1">
          <strong style={{ fontSize: '1.1rem', color: 'white' }}>{event.eventTitle}</strong>
        </div>
        <div>
          <span
            className="badge"
            style={{
              backgroundColor: getEventBadgeColor(event.eventType),
              fontSize: '0.85rem',
              padding: '0.3rem 0.4rem',
              fontWeight: 'normal'
            }}
          >
            {getEventTypeLabel(event.eventType)}
          </span>
          {event.scheduledAt && (
            <small className="ml-1" style={{ whiteSpace: 'nowrap', fontSize: '0.9rem', color: 'lightgray' }}>
              {formatDate(event.scheduledAt)}
            </small>
          )}
        </div>
        {showDescription && event.eventDescription && (
        <div className="mt-1">
            <small className="text-muted d-block">
                {event.eventDescription}
            </small>
          </div>
        )}
      </div>
      {canEdit && (
        <div style={{ position: "absolute", bottom: "8px", right: "8px", fontSize: "0.85em" }}>
          <FontAwesomeIcon className="icon-pen cursor-pointer" icon={faPencilAlt} style={{ color: '#aaa' }} />
        </div>
      )}
    </ListGroup.Item>
  );
};

export default EventCard;
